import { Box, Button, Typography } from "@mui/material";
import FlexBox from "components/common/FlexBox";
import { Bot, Zap } from "lucide-react";
import useIsMobile from "components/hooks/useIsMobile";

interface StartAgentPromptProps {
  onClick: () => void;
  disabled?: boolean;
}

export default ({ onClick, disabled = false }: StartAgentPromptProps) => {
  const isMobile = useIsMobile();
  return (
    /* Gradient border container */
    <Box
      sx={{
        background: "linear-gradient(171deg, #B3DEDD, #8CC6C6)",
        padding: "2px",
        borderRadius: "12px",
        marginBottom: "20px",
      }}
    >
      {/* Banner content */}
      <FlexBox
        stackedMobile
        justifyContent="space-between"
        sx={{
          padding: "12px 16px",
          background: "white",
          borderRadius: "11px",
        }}
      >
        <FlexBox>
          {!isMobile && (
            <Zap
              size={20}
              stroke="#198282"
              style={{
                flexShrink: 0,
              }}
            />
          )}
          <Typography variant="bodyHeavy">
            Use the Faye Task Agent to help you complete this task
          </Typography>
        </FlexBox>
        <Button
          onClick={onClick}
          disabled={disabled}
          variant="contained"
          endIcon={<Bot size={20} />}
          size="small"
        >
          Run agent
        </Button>
      </FlexBox>
    </Box>
  );
};
